/**
 * Formatters del feature inventarios: diferencias y códigos de almacén.
 */

/**
 * Formatea una diferencia numérica anteponiendo '+' a los valores positivos
 * (sobrante), dejando el signo '-' tal cual en los negativos (faltante), y
 * sin signo en el cuadre exacto, para distinguir de un vistazo sin depender
 * solo del color.
 *
 * @param {number|null} diferencia - Diferencia (cantidadContada - stockTeorico), o null si la línea no se ha contado
 * @returns {string} Diferencia formateada, o '-' si la línea aún no se contó
 */
export const formatDiferencia = (diferencia) => {
    if (diferencia === null || diferencia === undefined) return "-";
    if (diferencia > 0) return `+${diferencia}`;
    return `${diferencia}`;
};

/**
 * Código de almacén con dos dígitos ("1" -> "01"), como lo usan Eurowin y el backend
 * @param {string|number|null} codigo - Código tal como llega
 * @returns {string} Código normalizado
 */
export const normalizarCodigoAlmacen = (codigo) => String(codigo ?? "").trim().padStart(2, "0");
